import styled from "styled-components";

const StyledApp = styled.div`
  max-width: 800px;
  margin: auto;
  padding: 20px 40px;
  box-sizing: border-box;

  h1 {
    border: 1px solid red;
  }

  .columns {
    display: flex;
    justify-content: center;
    align-items: stretch;

    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }

    > div {
      width: 100%;
      padding: 10px 20px;
      display: flex;

      @media (min-width: 769px) {
        width: 50%;
      }
    }

    .status-container {
      overflow: hidden;
      padding: 0;
      margin: 10px 20px;
      max-width: 400px;
    }
  }
`;

export default StyledApp;
